/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Field_Project_Instructions_Q1_C1Inputs */



/**
* | output |
* | --- |
* | "Customer support and enquiries" |
*
* @param {Uno_Field_Project_Instructions_Q1_C1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_field_project_instructions_q1_c1 = /** @type {((inputs?: Uno_Field_Project_Instructions_Q1_C1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Field_Project_Instructions_Q1_C1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kundenanfragen und Support")
	return /** @type {LocalizedString} */ ("Customer support and enquiries")
});